import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, rufe } from "../api/client";
import type { LadenEinstellungen, LadenStammdaten } from "@shared/schemas/laden";

export interface LadenDaten {
  id: string;
  name: string;
  slug: string;
  adresse: { strasse?: string; plz?: string; ort?: string };
  telefon: string;
  email: string;
  steuernummer: string;
  ustModus: "regel19" | "kleinunternehmer";
  status: string;
  sumupVerbunden: boolean;
  abo: { aboStatus: "test" | "aktiv" | "verzug" | "gekuendigt" | "frei"; testphaseBis: string | null; aboBis: string | null; testTageRest: number | null; gesperrt: boolean; grund: string | null; stripe: boolean };
  einstellungen: LadenEinstellungen;
}

export function useLaden() {
  return useQuery({ queryKey: ["laden"], queryFn: () => rufe<LadenDaten>(api.api.laden.$get()) });
}

export function useUebersicht() {
  return useQuery({ queryKey: ["laden", "uebersicht"], queryFn: () => rufe<{ regale: number; mieter: number; artikelImRegal: number }>(api.api.laden.uebersicht.$get()) });
}

export function useStammdatenSpeichern() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (daten: LadenStammdaten) => rufe(api.api.laden.stammdaten.$put({ json: daten })),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["laden"] }),
  });
}

export interface ProtokollEintrag {
  nr: number;
  zeitpunkt: string;
  akteur: string;
  bereich: string;
  aktion: string;
  objekt: string | null;
  vorher: string | null;
  nachher: string | null;
  hash: string;
}

export function useProtokoll() {
  return useQuery({ queryKey: ["laden", "protokoll"], queryFn: () => rufe<{ eintraege: ProtokollEintrag[] }>(api.api.laden.protokoll.$get({ query: { limit: "100" } })) });
}

export function useProtokollPruefung() {
  return useQuery({ queryKey: ["laden", "protokoll", "pruefung"], queryFn: () => rufe<{ ok: boolean; anzahl?: number; nr?: number; grund?: string }>(api.api.laden.protokoll.pruefung.$get()) });
}
